<div class="container-fluid cardGroup px-0">
  <h1 class="text-black f-14 fw-600">{{ "Today" | translate | async }}</h1>
  <div class="row dashboard-card-details">
    <div class="col-lg-4 col-md-6 col-sm-6 page-card-main">
      <div class="mini-card">
        <div class="row g-0 net-dashboard-row">
          <div class="col-8">
            <div class="f-14 mb-1 fw-600 net-deshboard-sales">
              {{ "Net Sales" | translate | async }}
              <i
                class="f-10 fas fa-info-circle vertical-align-super"
                [ngbPopover]="'Net sales is the total amount of sales revenue generated after deducting discounts, taxes, and returns from gross sales.' | translate | async"
                triggers="mouseenter:mouseleave"
                [popoverTitle]="'Net Sales' | translate | async"
                placement="right"
              ></i>
            </div>
            <div class="pb-2 net-dashboard-details">
              <span
                  [ngClass]="
                    checkNegative(cardData?.sale?.percentage)
                      ? 'danger-badge'
                      : checkZeroInc(cardData?.sale?.percentage)
                      ? 'zero-badge'
                      : 'sucess-badge'
                  "
                  class="f-12 text-nowrap ms-0"
                >
                <!-- change -->
                  {{
                    checkNegative(cardData?.sale?.percentage)
                      ? cardData?.sale?.percentage
                      : showPlusData(cardData?.sale?.percentage)
                  }}%
                  </span>
             </div>
           <div class="d-flex net-dashboard-currency">
            <h6 class="fw-600 f-14 d-flex gap-1">
              <div class="sales-card-width-currency">{{ currency }}</div>
              <div class="sales-card-width" >
                {{ cardData?.sale?.value | lakhSeparator }}

              </div>
              <!-- {{ currency + " " + (cardData?.sale?.value | number : '.2-2') }} -->
            </h6>

           </div>
          </div>
          <div class="col-4">
            <div class="eos--icon net-sales"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-6 page-card-main">
      <div class="mini-card">
        <div class="row g-0 align-items-start net-dashboard-row">
          <div class="col-9">
            <div class="f-14 mb-1 fw-600 net-deshboard-sales">
              {{ "Total Orders" | translate | async }}
              <i
                class="f-10 fas fa-info-circle vertical-align-super"
                [ngbPopover]="'Total Orders: an overview of all orders made and processed.' | translate | async"
                triggers="mouseenter:mouseleave"
                [popoverTitle]="'Total Orders' | translate | async"
                placement="right"
              ></i>
            </div>
            <div class="pb-2 net-dashboard-details">
              <span
                [ngClass]="
                  checkNegative(cardData?.order?.percentage)
                    ? 'danger-badge'
                    : checkZeroInc(cardData?.order?.percentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
                class="f-12 text-nowrap ms-0"
              >
                {{
                  checkNegative(cardData?.order?.percentage)
                    ? cardData?.order?.percentage
                    : showPlusData(cardData?.order?.percentage)
                }}%</span
              >
            </div>
            <div class="d-flex net-dashboard-currency">
              <h6 class="fw-600 f-14 sales-card-width"  >
                {{ cardData?.order?.value | lakhSeparator }}
              </h6>
            </div>
          </div>
          <div class="col-3">
            <div class="eos--icon total-orders"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-6 page-card-main">
      <div class="mini-card">
        <div class="row g-0 net-dashboard-row">
          <div class="col-8">
            <div class="f-14 mb-1 fw-600 net-deshboard-sales">
              {{ "Total Transactions" | translate | async }}
              <i
                class="f-10 fas fa-info-circle vertical-align-super"
                [ngbPopover]="'Total Transactions: Comprehensive, cumulative transactions data. Detailed records of sales, purchases and payments.' | translate | async"
                triggers="mouseenter:mouseleave"
                [popoverTitle]="'Total Transactions' | translate | async"
                placement="right"
              ></i>
            </div>
            <div class="pb-2 net-dashboard-details">
              <span
              [ngClass]="
                checkNegative(cardData?.transaction?.percentage)
                  ? 'danger-badge'
                  : checkZeroInc(cardData?.transaction?.percentage)
                  ? 'zero-badge'
                  : 'sucess-badge'
              "
              class="f-12 text-nowrap ms-0"
            >
              {{
                checkNegative(cardData?.transaction?.percentage)
                  ? cardData?.transaction?.percentage
                  : showPlusData(cardData?.transaction?.percentage)
              }}%</span
            >
            </div>
         <div class="d-flex net-dashboard-currency">
          <h6 class="fw-600 f-14 sales-card-width"  >
            {{ cardData?.transaction?.value | lakhSeparator }}
          </h6>

         </div>
          </div>
          <div class="col-4">
            <div class="eos--icon total-transactions"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-6 page-card-main">
      <div class="mini-card">
        <div class="row g-0 net-dashboard-row">
          <div class="col-8">
            <div class="f-14 mb-1 fw-600 net-deshboard-sales">
              {{ "Total Refunds" | translate | async }}
              <i
                class="f-10 fas fa-info-circle vertical-align-super"
                [ngbPopover]="'Total Refunded: The total amount returned to customers due to a purchase cancellation or return.' | translate | async"
                triggers="mouseenter:mouseleave"
                [popoverTitle]="'Total Refunds' | translate | async"
                placement="right"
              ></i>
            </div>
            <div class="pb-2 net-dashboard-details">
              <span
                [ngClass]="
                  checkNegative(cardData?.refund?.percentage)
                    ? 'danger-badge'
                    : checkZeroInc(cardData?.refund?.percentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
                class="f-12 text-nowrap ms-0"
              >
                {{
                  checkNegative(cardData?.refund?.percentage)
                    ? cardData?.refund?.percentage
                    : showPlusData(cardData?.refund?.percentage)
                }}%</span
              >
            </div>
            <div class="d-flex net-dashboard-currency">
              <h6 class="fw-600 f-14 d-flex gap-1">
                <div class="sales-card-width-currency" >{{ currency }}</div>
                  <div class="sales-card-width"  >
                    {{ cardData?.refund?.value | lakhSeparator  }}
                  </div>

              </h6>

            </div>
          </div>
          <div class="col-4">
            <div class="eos--icon total-refunds"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-6 page-card-main">
      <div class="mini-card" style="">
        <div class="row g-0 net-dashboard-row">
          <div class="col-8">
            <div class="f-14 mb-1 fw-600 net-deshboard-sales">
              {{ "Total Discounts" | translate | async }}
              <i
                class="f-10 fas fa-info-circle vertical-align-super"
                [ngbPopover]="'Total Discounts: The total amount of discounts that have been processed over a given period of time' | translate | async"
                triggers="mouseenter:mouseleave"
                [popoverTitle]="'Total Discounts' | translate | async"
                placement="bottom"
              ></i>
            </div>
            <div class="pb-2 net-dashboard-details">
              <span
              [ngClass]="
                checkNegative(cardData?.discount?.percentage)
                  ? 'danger-badge'
                  : checkZeroInc(cardData?.discount?.percentage)
                  ? 'zero-badge'
                  : 'sucess-badge'
              "
              class="f-12 text-nowrap ms-0"
            >
              {{
                checkNegative(cardData?.discount?.percentage)
                  ? cardData?.discount?.percentage
                  : showPlusData(cardData?.discount?.percentage)
              }}%</span
            >
            </div>
           <div class="d-flex net-dashboard-currency">
            <h6 class="fw-600 f-14 d-flex gap-1">
              <div class="sales-card-width-currency">{{ currency }}</div>
              <div class="sales-card-width"> {{ cardData?.discount?.value | lakhSeparator  }}</div>
            </h6>
           </div>
          </div>
          <div class="col-4">
            <div class="eos--icon total-discounts"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
